import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ReportsPage.CardToolbar.AccrualsCreationPopup.SuccessPopupContent', {
    title: 'Draft Manual Journal created successfully',
    description: 'Find it in your draft requests section or open it in a new tab now.',
    buttonText: 'Open in new tab',
});
